import { useAtomValue } from 'jotai';

// Atoms
import { openedMessageAtom } from '@/components/pages/conversations/SocialInbox/atoms';

// Components
import {
    SocialInboxMenuMobile,
    SocialInboxMessageList,
    SocialInboxChatView
} from '@/components/pages/conversations/SocialInbox';

export const SocialInboxMobile = () => {
    const openedMessage = useAtomValue(openedMessageAtom);

    return (
        <div data-testid="social-inbox-mobile" className="flex size-full flex-col gap-px lg:hidden">
            {openedMessage ? (
                <SocialInboxChatView />
            ) : (
                <>
                    <SocialInboxMenuMobile />
                    <SocialInboxMessageList className="grow p-5" />
                </>
            )}
        </div>
    );
};
